import { useRef } from "react";

// rc-slider lets you click anywhere on the rail to move the handle (click-to-set),
// which we want to keep. The only unwanted case is the stray rail click that fires
// right after releasing a handle drag, which would change the value just set. So we
// allow rail clicks normally and only swallow one that lands within a short window
// after a drag release. Spread the returned props on the slider wrapper element.
const POST_RELEASE_BLOCK_MS = 250;

export const useSliderRailGuard = () => {
  const draggingRef = useRef(false);
  const releasedAtRef = useRef(0);

  const isOnHandle = (target) => !!(target && target.closest && target.closest(".rc-slider-handle"));

  const onMouseDownCapture = (e) => {
    if (isOnHandle(e.target)) {
      draggingRef.current = true;
      return;
    }
    if (Date.now() - releasedAtRef.current < POST_RELEASE_BLOCK_MS) {
      e.stopPropagation();
      return;
    }
    // a deliberate rail click that may turn into a drag
    draggingRef.current = true;
  };

  const onMouseUpCapture = () => {
    if (draggingRef.current) {
      releasedAtRef.current = Date.now();
      draggingRef.current = false;
    }
  };

  return { onMouseDownCapture, onMouseUpCapture };
};
